<script setup lang="ts">
import { useFlowStore } from '@/stores/flow';
import ErrorBanner from './ErrorBanner.vue';

const flow = useFlowStore();
</script>

<template>
  <section class="screen">
    <h1 class="title">Voucher accepted</h1>
    <div v-if="flow.productNames.length" class="unlocked">
      <div class="unlocked-eyebrow">You've unlocked</div>
      <ul class="product-list">
        <li v-for="name in flow.productNames" :key="name">
          <span class="bullet" aria-hidden="true">●</span>
          <span>{{ name }}</span>
        </li>
      </ul>
    </div>

    <p class="lede">
      Now we just need to put it on an account. Sign in if you already have one,
      or create a new account in under a minute.
    </p>

    <ErrorBanner
      v-if="flow.error"
      :message="flow.error"
      @dismiss="flow.clearError()"
    />

    <div class="auth-actions">
      <button
        class="btn btn-primary btn-block"
        type="button"
        :disabled="flow.busy"
        @click="flow.goToCreateAccount()"
      >
        Create an account
      </button>
      <button
        class="btn btn-outline btn-block"
        type="button"
        :disabled="flow.busy"
        @click="flow.goToSignIn()"
      >
        I already have an account
      </button>
    </div>

    <button class="link-btn" type="button" @click="flow.goBackToCode()">
      ← Use a different code
    </button>
  </section>
</template>

<style scoped>
.screen { display: flex; flex-direction: column; }

.title {
  font-family: 'Fraunces', Georgia, serif;
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  letter-spacing: -0.02em;
  color: var(--coco-900);
  margin: 0 0 1.25rem;
  font-weight: 500;
  font-variation-settings: 'SOFT' 50, 'opsz' 96;
}

.unlocked {
  background: linear-gradient(135deg, var(--lime-100), var(--lime-50));
  border: 1px solid var(--lime-200);
  border-radius: 12px;
  padding: 0.85rem 1rem;
  margin-bottom: 1rem;
}
.unlocked-eyebrow {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: var(--lime-700);
  font-weight: 600;
  margin-bottom: 0.35rem;
}
.product-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.product-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: var(--coco-900);
}
.bullet {
  color: var(--lime-600);
  font-size: 0.7rem;
}

.lede {
  margin: 0 0 1.5rem;
  color: var(--ink-soft);
  line-height: 1.55;
}

.auth-actions {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 1rem;
}

.link-btn {
  background: none;
  border: none;
  color: var(--coco-700);
  cursor: pointer;
  padding: 0.4rem 0;
  font: inherit;
  font-size: 0.88rem;
  align-self: flex-start;
}
.link-btn:hover { color: var(--coco-900); }
</style>
